import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-554ad9d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "guide"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cover"
}, null, -1));
const _hoisted_3 = {
  class: "guide-list"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, " 点击卡片查看更多信息 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PluginItem = _resolveComponent("PluginItem");
  return _ctx.isVisible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_PluginItem, {
    plugin: _ctx.plugin
  }, null, 8, ["plugin"])]), _hoisted_4, _createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.close && _ctx.close(...args))
  }, " 我知道了 ")])) : _createCommentVNode("", true);
}